module.exports = __webpack_public_path__ + "static/img/alliance-logo2-5.884d206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/alliance-logo2-5.png
// module id = oVLD
// module chunks = 0